export const DegreeList = [
    "Bachelor of Arts (B.A)",
    "Bachelor of Arts Bachelor of Education (B.A. B.Ed)",
    "Bachelor of Arts Bachelor of Law (B.A.B.L)",
    "Bachelor of Arts Bachelor of Law (B.A.LLB)",
    "Bachelor of Ayurvedic Medicine and Surgery (B.A.M.S)",
    "Bachelor of Applied Sciences (B.A.S)",
    "Bachelor of Arts (B.A.S.L.P)",
    "Bachelor of Audiology and Speech Language Pathology (B.A.S.L.P)",
    "Bachelor of Architecture (B.Arch)",
    "Bachelor of Business Administration (B.B.A)",
    "Bachelor of Business Administration Bachelor of Law (B.B.A LL.B)",
    "Bachelor of Business Management (B.B.M)",
    "Bachelor of Business Studies (B.B.S)",
    "Bachelor of Computer Applications (B.C.A)",
    "Bachelor of Communication Journalism (B.C.J)",
    "Bachelor of Computer Science (B.C.S)",
    "Bachelor of Commerce (B.Com)",
    "Bachelor of Divinity (B.D)",
    "Bachelor of Dental Surgery (B.D.S)",
    "Basic Development Therapy (B.D.T)",
    "Bachelor of Design (B.Des)",
    "Bachelor of Engineering (B.E)",
    "Bachelor of Electronic Science (B.E.S)",
    "Bachelor of Education (B.Ed)",
    "Bachelor of education in Artificial Intelligence (B.Ed AI)",
    "Bachelor of Education (B.EdQ)",
    "Bachelor of Elementary Education (B.EI.ED)",
    "Bachelor of Elementary Education (B.EL.Ed)",
    "Bachelor of Fine Arts (B.F.A)",
    "Bachelor of Financial Investment and Analysis (B.F.I.A)",
    "Bachelor of Fishery Sciences (B.F.S)",
    "Bachelor of Fashion Technology (B.F.Tech)",
    "Bachelor of General Law (B.G.L)",
    "Behavioral Healthcare Education (B.H.Ed)",
    "Bachelor of Hotel Management (B.H.M)",
    "Bachelor Hotel Management and Catering Technology (B.H.M.C.T)",
    "Bachelor of Homeopathic Medicine & Surgery (B.H.M.S)",
    "Bachelor of Hospitality and Tourism Management (B.H.T.M)",
    "Bachelor of Information Systems Management (B.I.S.M)",
    "Bachelor of Laws (B.L)",
    "Bachelor of Library and Information Science (B.L.I.S)",
    "Bachelor of Labour Management (B.L.M)",
    "Bachelor Library Science (B.L.Sc)",
    "Bachelor of Literature (B.Lit)",
    "Bachelor of Medical Laboratory Technology (B.M.L.T)",
    "Bachelor of Mental Retardation (B.M.R)",
    "Bachelor of Medical Record Science (B.M.R.Sc)",
    "Bachelor in Mobility Science (B.M.Sc)",
    "Bachelor of Mobility Science (B.M.Sc)",
    "Bachelor of Medical Technology (B.M.T)",
    "Bachelor of Naturopathy and Yogic Sciences (B.N.Y.Sc)",
    "Bachelor of Occupational Therapy (B.O.T)",
    "Bachelor of Occupational Therapy (B.O.Th)",
    "Bachelor of Optometry and Vision Science (B.Optom)",
    "Bachelor of Physical Education (B.P.E)",
    "Bachelor Of Physical Education (B.P.Ed)",
    "Bachelor in Prosthetics and Orthotics (B.P.O)",
    "Bachelor of Public Relations (B.P.R)",
    "Bachelor of Physiotherapy (B.P.T)",
    "Bachelor of Pharmacy (B.Pharma)",
    "Bachelor of Rehabilitation Therapy (B.R.T)",
    "Bachelor of Science (B.S)",
    "Bachelor in Science Education (B.S.E)",
    "Bachelor of Speech Language & Audiology (B.S.L.A)",
    "Bachelor of Socio Legal Sciences Bachelor of Laws (B.S.L.LL.B)",
    "Bachelor of Siddha Medical Sciences (B.S.M.S)",
    "Bachelor Of Social Work (B.S.W)",
    "Bachelor of Science (B.Sc)",
    "Bachelor of Science Bachelor of Education (B.Sc.B.Ed)",
    "Bachelor of Science in Education (B.Sc.Ed)",
    "Bachelor of Tourism Administration (B.T.A)",
    "Basic Training Certificate (B.T.C)",
    "Bachelor of Technology (B.Tech)",
    "Bachelors of Technology (B.Tech)",
    "Bachelor of Unani Medicine & Surgery (B.U.M.S)",
    "Bachelor of Veterinary Science (B.V.Sc)",
    "Bachelor of Medicine (Bachelor of Medicine)",
    "Bachelor of Journalism and Mass Communication (BJMC)",
    "Diploma in Special Education (D.S.E (CP))",
    "Bachelor of Unani Medicine & Surgery (Kamil e Tob o Jarahat)",
    "Bachelor of Law (LL.B)",
    "Bachelor of Medicine Bachelor of Surgery (M.B.B.S)",
    "Master of Journalism and Mass Communication (MJMC)",
    "Doctor of Philosophy (Ph. D)",
    "Clinical Psychology (Psy.D (Cl.Psy))",
    "Master of Science (BOTANY)",
    "Diploma in Medical (D.M)",
    "Executive Fellow Program In Management (E.F.P.M)",
    "Executive Management Programme (E.M.P)",
    "NULL (EPGP)",
    "Fellow Programme in Management (F.P.M)",
    "FACULTY DEVELOPMENT PROGRAMME (FDP)",
    "Executive Fellow Programme in Management (FELLOWSHIP)",
    "FELLOW PROGRAMME IN MANAGEMENT (FELLOWSHIP)",
    "FELLOW PROGRAMME IN MANAGEMENT (FPM)",
    "Master of Law (LL.M)",
    "Master of Arts (M.A)",
    "Master of Arts (M.A. (SWDS))",
    "Master of Arts in Management (M.A.M)",
    "Master of Arts in Personal Management (M.A.P.M)",
    "Master of Arts (M.A.S.L.P)",
    "Master of Audiology & Speech Language Pathology (M.A.S.L.P)",
    "Master of Arts in Theatre & Television (M.A.T.T)",
    "Master of Architecture (M.Arch)",
    "Master of Business Administration (M.B.A)",
    "Master of Business Economics (M.B.E)",
    "Master of Business Laws (M.B.L)",
    "Master of Business Management (M.B.M)",
    "Master of Business Studies (M.B.S)",
    "Master of Computer Applications (M.C.A)",
    "Master of Communication & Journalism (M.C.J)",
    "Master of Comparative Laws (M.C.L)",
    "Master of Computer Management (M.C.M)",
    "Master of Corporate Secretaryship (M.C.S)",
    "Master of Chirurgical (M.Ch)",
    "Master of Commerce (M.Com)",
    "Doctor of Medicine (M.D)",
    "Sports Medicine (M.D)",
    "Management Development Programme (M.D.P)",
    "Master of Dental Surgery (M.D.S)",
    "Master of Design (M.Des)",
    "Master of Engineering (M.E)",
    "Master of Education (M.Ed)",
    "Master of education in Artificial Intelligence (M.Ed AI)",
    "Master of Fine Arts (M.F.A)",
    "Master of Finance & Control (M.F.C)",
    "Master of Film Management (M.F.M)",
    "Master of Financial Services (M.F.S)",
    "Master of Fishery Science (M.F.Sc)",
    "Master of Fishery Sciences (M.F.Sc)",
    "Master of Foreign Trade (M.F.T)",
    "Master of Hospital Administration (M.H.A)",
    "Master of Hospitality & Hotel Management (M.H.H.M)",
    "Master of Hospitality Management (M.H.M)",
    "Master of Human Resource Management (M.H.R.M)",
    "Master Of Health Science (M.H.Sc)",
    "Masters of Hospitality and Tourism Management (M.H.T.M)",
    "Master of International Business (M.I.B)",
    "Master of Information Management (M.I.M)",
    "Master of Journalism (M.J)",
    "Master of Laws (M.L)",
    "Master of Library and Information Science (M.L.I.Sc)",
    "Master of Labour Management (M.L.M)",
    "Master of Library Science (M.L.Sc)",
    "Master of Marketing Management (M.M.M)",
    "Master of Management Program (M.M.P)",
    "Master of Management Studies (M.M.S)",
    "Master of Occupational Theraphy (M.O.T)",
    "Master of Performing Arts (M.P.A)",
    "Master of Psychiatric Epidemiology (M.P.E)",
    "Master Of Physical Education (M.P.Ed)",
    "Master of Public Health (M.P.H)",
    "Masters Programme in International Business (M.P.I.B)",
    "Master of Performance Management (M.P.M)",
    "Diploma in Prosthetics & Orthotics (M.P.O)",
    "Masters in Public Systems Management (M.P.S.M)",
    "Master of Physiotheraphy (M.P.T)",
    "Master of Pharmacy (M.Pharma)",
    "Master of Philosophy (M.Phil)",
    "Master of Rehabilitation Science (M.R.Sc)",
    "M.S. in Library and Information Science (M.S)",
    "Master of Science (M.S)",
    "Master of Social Dynamics (M.S.D)",
    "Masters Programme In Sports Physiotheraphy (M.S.P.T)",
    "Master of Social Work (M.S.W)",
    "Master of Science (M.Sc)",
    "Master of Tourism Administrations (M.T.A)",
    "Master of Tourism Management (M.T.M)",
    "Master of Technology (M.Tech)",
    "Master of Veterinary Science (M.V.Sc)",
    "Doctor of Medicine Unani (Mahir e Tibb)",
    "Master of Business Administration (MBA)",
    "MANAGEMENT DEVELOPMENT PROGRAMEE (MDP)",
    "Master of Industrial Relation and Personal Management (MIR and PM)",
    "Master of Personnel Management (MPM)",
    "Master of Personal Management and Industrial Relation (MPM and IR)",
    "Post Graduate Diploma (P Diplomo)",
    "Post Graduate Diploma (P.G.D.D.R.M)",
    "Post Graduate Diploma (P.G.D.D.T.(MD:P&N))",
    "Post Graduate Diploma (P.G.D.E.I)",
    "Post Graduate Diploma (P.G.D.R.P)",
    "Post Graduate Diploma (P.G.D.S.E.(MR))",
    "Post Graduate Programme (P.G.P)",
    "Post Graduate (PG)",
    "Post Graduate Diploma (PG Diploma)",
    "Post Graduate Programme (PG Programme)",
    "Post Graduate Diploma (PGD)",
    "POST GRADUATE PROGRAME FOR EXECUTIVES (PGEXP)",
    "POST-GRADUATE PROGRAMME IN MANAGEMENT (PGP)",
    "POST GRADUATE PROGRAMME IN AGRIBUSINESS MANAGEMENT (PGP-ABM)",
    "PUBLIC MANAGEMENT AND POLICY (PGP-PMP)",
    "PGPX IN -VISIONARY LEADERSHIP IN MANUFACTURING (PGPEX-VLM)",
    "POST GRADUATE PROGRAME IN MANAGEMENT (PGPM)",
    "MANAGEMENT FOR EXECUTIVES (PGPX)",
    "Doctor of Philosophy (Ph. D)",
    "Doctor of Philosophy (Ph.D)",
    "Visual Information Processing (Visual Information Processing)",
    "Diploma",
    "Polytechnic",
    "ITI",
    "High School",
];

export const countryList = [
    "India",
    "Afghanistan",
    "Albania",
    "Algeria",
    "American Samoa",
    "Andorra",
    "Angola",
    "Anguilla",
    "Antarctica",
    "Antigua and Barbuda",
    "Argentina",
    "Armenia",
    "Aruba",
    "Australia",
    "Austria",
    "Azerbaijan",
    "Bahamas (the)",
    "Bahrain",
    "Bangladesh",
    "Barbados",
    "Belarus",
    "Belgium",
    "Belize",
    "Benin",
    "Bermuda",
    "Bhutan",
    "Bolivia (Plurinational State of)",
    "Bonaire, Sint Eustatius and Saba",
    "Bosnia and Herzegovina",
    "Botswana",
    "Bouvet Island",
    "Brazil",
    "British Indian Ocean Territory (the)",
    "Brunei Darussalam",
    "Bulgaria",
    "Burkina Faso",
    "Burundi",
    "Cabo Verde",
    "Cambodia",
    "Cameroon",
    "Canada",
    "Cayman Islands (the)",
    "Central African Republic (the)",
    "Chad",
    "Chile",
    "China",
    "Christmas Island",
    "Cocos (Keeling) Islands (the)",
    "Colombia",
    "Comoros (the)",
    "Congo (the Democratic Republic of the)",
    "Congo (the)",
    "Cook Islands (the)",
    "Costa Rica",
    "Croatia",
    "Cuba",
    "Curaçao",
    "Cyprus",
    "Czechia",
    "Côte d'Ivoire",
    "Denmark",
    "Djibouti",
    "Dominica",
    "Dominican Republic (the)",
    "Ecuador",
    "Egypt",
    "El Salvador",
    "Equatorial Guinea",
    "Eritrea",
    "Estonia",
    "Eswatini",
    "Ethiopia",
    "Falkland Islands (the) [Malvinas]",
    "Faroe Islands (the)",
    "Fiji",
    "Finland",
    "France",
    "French Guiana",
    "French Polynesia",
    "French Southern Territories (the)",
    "Gabon",
    "Gambia (the)",
    "Georgia",
    "Germany",
    "Ghana",
    "Gibraltar",
    "Greece",
    "Greenland",
    "Grenada",
    "Guadeloupe",
    "Guam",
    "Guatemala",
    "Guernsey",
    "Guinea",
    "Guinea-Bissau",
    "Guyana",
    "Haiti",
    "Heard Island and McDonald Islands",
    "Holy See (the)",
    "Honduras",
    "Hong Kong",
    "Hungary",
    "Iceland",

    "Indonesia",
    "Iran (Islamic Republic of)",
    "Iraq",
    "Ireland",
    "Isle of Man",
    "Israel",
    "Italy",
    "Jamaica",
    "Japan",
    "Jersey",
    "Jordan",
    "Kazakhstan",
    "Kenya",
    "Kiribati",
    "Korea (the Democratic People's Republic of)",
    "Korea (the Republic of)",
    "Kuwait",
    "Kyrgyzstan",
    "Lao People's Democratic Republic (the)",
    "Latvia",
    "Lebanon",
    "Lesotho",
    "Liberia",
    "Libya",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Macao",
    "Madagascar",
    "Malawi",
    "Malaysia",
    "Maldives",
    "Mali",
    "Malta",
    "Marshall Islands (the)",
    "Martinique",
    "Mauritania",
    "Mauritius",
    "Mayotte",
    "Mexico",
    "Micronesia (Federated States of)",
    "Moldova (the Republic of)",
    "Monaco",
    "Mongolia",
    "Montenegro",
    "Montserrat",
    "Morocco",
    "Mozambique",
    "Myanmar",
    "Namibia",
    "Nauru",
    "Nepal",
    "Netherlands (the)",
    "New Caledonia",
    "New Zealand",
    "Nicaragua",
    "Niger (the)",
    "Nigeria",
    "Niue",
    "Norfolk Island",
    "Northern Mariana Islands (the)",
    "Norway",
    "Oman",
    "Pakistan",
    "Palau",
    "Palestine, State of",
    "Panama",
    "Papua New Guinea",
    "Paraguay",
    "Peru",
    "Philippines (the)",
    "Pitcairn",
    "Poland",
    "Portugal",
    "Puerto Rico",
    "Qatar",
    "Republic of North Macedonia",
    "Romania",
    "Russian Federation (the)",
    "Rwanda",
    "Réunion",
    "Saint Barthélemy",
    "Saint Helena, Ascension and Tristan da Cunha",
    "Saint Kitts and Nevis",
    "Saint Lucia",
    "Saint Martin (French part)",
    "Saint Pierre and Miquelon",
    "Saint Vincent and the Grenadines",
    "Samoa",
    "San Marino",
    "Sao Tome and Principe",
    "Saudi Arabia",
    "Senegal",
    "Serbia",
    "Seychelles",
    "Sierra Leone",
    "Singapore",
    "Sint Maarten (Dutch part)",
    "Slovakia",
    "Slovenia",
    "Solomon Islands",
    "Somalia",
    "South Africa",
    "South Georgia and the South Sandwich Islands",
    "South Sudan",
    "Spain",
    "Sri Lanka",
    "Sudan (the)",
    "Suriname",
    "Svalbard and Jan Mayen",
    "Sweden",
    "Switzerland",
    "Syrian Arab Republic",
    "Taiwan",
    "Tajikistan",
    "Tanzania, United Republic of",
    "Thailand",
    "Timor-Leste",
    "Togo",
    "Tokelau",
    "Tonga",
    "Trinidad and Tobago",
    "Tunisia",
    "Turkey",
    "Turkmenistan",
    "Turks and Caicos Islands (the)",
    "Tuvalu",
    "Uganda",
    "Ukraine",
    "United Arab Emirates (the)",
    "United Kingdom of Great Britain and Northern Ireland (the)",
    "United States Minor Outlying Islands (the)",
    "United States of America (the)",
    "Uruguay",
    "Uzbekistan",
    "Vanuatu",
    "Venezuela (Bolivarian Republic of)",
    "Viet Nam",
    "Virgin Islands (British)",
    "Virgin Islands (U.S.)",
    "Wallis and Futuna",
    "Western Sahara",
    "Yemen",
    "Zambia",
    "Zimbabwe",
    "Åland Islands",
    "Others"
];

export const statesList = {
    states: [
        {
            id: "1",
            type: "Union Territory",
            capital: "Mayabunder",
            code: "AN",
            name: "Andaman and Nicobar Islands",
            districts: [
                {
                    id: "1",
                    name: "Nicobar",
                },
                {
                    id: "2",
                    name: "North and Middle Andaman",
                },
                {
                    id: "3",
                    name: "South Andaman",
                },
            ],
        },
        {
            id: "2",
            type: "State",
            capital: "Amaravati",
            code: "AP",
            name: "Andhra Pradesh",
            districts: [
                {
                    id: "1",
                    name: "Anantapur",
                },
                {
                    id: "2",
                    name: "Chittoor",
                },
                {
                    id: "3",
                    name: "East Godavari",
                },
                {
                    id: "4",
                    name: "Guntur",
                },
                {
                    id: "5",
                    name: "Krishna",
                },
                {
                    id: "6",
                    name: "Kurnool",
                },
                {
                    id: "7",
                    name: "Nellore",
                },
                {
                    id: "8",
                    name: "Prakasam",
                },
                {
                    id: "9",
                    name: "Srikakulam",
                },
                {
                    id: "10",
                    name: "Visakhapatnam",
                },
                {
                    id: "11",
                    name: "Vizianagaram",
                },
                {
                    id: "12",
                    name: "West Godavari",
                },
                {
                    id: "13",
                    name: "YSR Kadapa",
                },
            ],
        },
        {
            id: "3",
            type: "State",
            capital: "Itanagar",
            code: "AR",
            name: "Arunachal Pradesh",
            districts: [
                {
                    id: "1",
                    name: "Tawang",
                },
                {
                    id: "2",
                    name: "West Kameng",
                },
                {
                    id: "3",
                    name: "East Kameng",
                },
                {
                    id: "4",
                    name: "Papum Pare",
                },
                {
                    id: "5",
                    name: "Kurung Kumey",
                },
                {
                    id: "6",
                    name: "Kra Daadi",
                },
                {
                    id: "7",
                    name: "Lower Subansiri",
                },
                {
                    id: "8",
                    name: "Upper Subansiri",
                },
                {
                    id: "9",
                    name: "West Siang",
                },
                {
                    id: "10",
                    name: "East Siang",
                },
                {
                    id: "11",
                    name: "Siang",
                },
                {
                    id: "12",
                    name: "Upper Siang",
                },
                {
                    id: "13",
                    name: "Lower Siang",
                },
                {
                    id: "14",
                    name: "Lower Dibang Valley",
                },
                {
                    id: "15",
                    name: "Dibang Valley",
                },
                {
                    id: "16",
                    name: "Anjaw",
                },
                {
                    id: "17",
                    name: "Lohit",
                },
                {
                    id: "18",
                    name: "Namsai",
                },
                {
                    id: "19",
                    name: "Changlang",
                },
                {
                    id: "20",
                    name: "Tirap",
                },
                {
                    id: "21",
                    name: "Longding",
                },
            ],
        },
        {
            id: "4",
            type: "State",
            capital: "Dispur",
            code: "AS",
            name: "Assam",
            districts: [
                {
                    id: "1",
                    name: "Baksa",
                },
                {
                    id: "2",
                    name: "Barpeta",
                },
                {
                    id: "3",
                    name: "Biswanath",
                },
                {
                    id: "4",
                    name: "Bongaigaon",
                },
                {
                    id: "5",
                    name: "Cachar",
                },
                {
                    id: "6",
                    name: "Charaideo",
                },
                {
                    id: "7",
                    name: "Chirang",
                },
                {
                    id: "8",
                    name: "Darrang",
                },
                {
                    id: "9",
                    name: "Dhemaji",
                },
                {
                    id: "10",
                    name: "Dhubri",
                },
                {
                    id: "11",
                    name: "Dibrugarh",
                },
                {
                    id: "12",
                    name: "Goalpara",
                },
                {
                    id: "13",
                    name: "Golaghat",
                },
                {
                    id: "14",
                    name: "Hailakandi",
                },
                {
                    id: "15",
                    name: "Hojai",
                },
                {
                    id: "16",
                    name: "Jorhat",
                },
                {
                    id: "17",
                    name: "Kamrup Metropolitan",
                },
                {
                    id: "18",
                    name: "Kamrup",
                },
                {
                    id: "19",
                    name: "Karbi Anglong",
                },
                {
                    id: "20",
                    name: "Karimganj",
                },
                {
                    id: "21",
                    name: "Kokrajhar",
                },
                {
                    id: "22",
                    name: "Lakhimpur",
                },
                {
                    id: "23",
                    name: "Majuli",
                },
                {
                    id: "24",
                    name: "Morigaon",
                },
                {
                    id: "25",
                    name: "Nagaon",
                },
                {
                    id: "26",
                    name: "Nalbari",
                },
                {
                    id: "27",
                    name: "Dima Hasao",
                },
                {
                    id: "28",
                    name: "Sivasagar",
                },
                {
                    id: "29",
                    name: "Sonitpur",
                },
                {
                    id: "30",
                    name: "South Salmara-Mankachar",
                },
                {
                    id: "31",
                    name: "Tinsukia",
                },
                {
                    id: "32",
                    name: "Udalguri",
                },
                {
                    id: "33",
                    name: "West Karbi Anglong",
                },
            ],
        },
        {
            id: "5",
            type: "State",
            capital: "Patna",
            code: "BR",
            name: "Bihar",
            districts: [
                {
                    id: "1",
                    name: "Araria",
                },
                {
                    id: "2",
                    name: "Arwal",
                },
                {
                    id: "3",
                    name: "Aurangabad",
                },
                {
                    id: "4",
                    name: "Banka",
                },
                {
                    id: "5",
                    name: "Begusarai",
                },
                {
                    id: "6",
                    name: "Bhagalpur",
                },
                {
                    id: "7",
                    name: "Bhojpur",
                },
                {
                    id: "8",
                    name: "Buxar",
                },
                {
                    id: "9",
                    name: "Darbhanga",
                },
                {
                    id: "10",
                    name: "East Champaran (Motihari)",
                },
                {
                    id: "11",
                    name: "Gaya",
                },
                {
                    id: "12",
                    name: "Gopalganj",
                },
                {
                    id: "13",
                    name: "Jamui",
                },
                {
                    id: "14",
                    name: "Jehanabad",
                },
                {
                    id: "15",
                    name: "Kaimur (Bhabua)",
                },
                {
                    id: "16",
                    name: "Katihar",
                },
                {
                    id: "17",
                    name: "Khagaria",
                },
                {
                    id: "18",
                    name: "Kishanganj",
                },
                {
                    id: "19",
                    name: "Lakhisarai",
                },
                {
                    id: "20",
                    name: "Madhepura",
                },
                {
                    id: "21",
                    name: "Madhubani",
                },
                {
                    id: "22",
                    name: "Munger (Monghyr)",
                },
                {
                    id: "23",
                    name: "Muzaffarpur",
                },
                {
                    id: "24",
                    name: "Nalanda",
                },
                {
                    id: "25",
                    name: "Nawada",
                },
                {
                    id: "26",
                    name: "Patna",
                },
                {
                    id: "27",
                    name: "Purnia (Purnea)",
                },
                {
                    id: "28",
                    name: "Rohtas",
                },
                {
                    id: "29",
                    name: "Saharsa",
                },
                {
                    id: "30",
                    name: "Samastipur",
                },
                {
                    id: "31",
                    name: "Saran",
                },
                {
                    id: "32",
                    name: "Sheikhpura",
                },
                {
                    id: "33",
                    name: "Sheohar",
                },
                {
                    id: "34",
                    name: "Sitamarhi",
                },
                {
                    id: "35",
                    name: "Siwan",
                },
                {
                    id: "36",
                    name: "Supaul",
                },
                {
                    id: "37",
                    name: "Vaishali",
                },
                {
                    id: "38",
                    name: "West Champaran",
                },
            ],
        },
        {
            id: "6",
            type: "Union Territory",
            capital: "Chandigarh",
            code: "CG",
            name: "Chandigarh",
            districts: [
                {
                    id: "1",
                    name: "Chandigarh",
                },
            ],
        },
        {
            id: "7",
            type: "State",
            capital: "Bilaspur (Judiciary), Raipur",
            code: "CH",
            name: "Chhattisgarh",
            districts: [
                {
                    id: "1",
                    name: "Balod",
                },
                {
                    id: "2",
                    name: "Baloda Bazar",
                },
                {
                    id: "3",
                    name: "Balrampur",
                },
                {
                    id: "4",
                    name: "Bastar",
                },
                {
                    id: "5",
                    name: "Bemetara",
                },
                {
                    id: "6",
                    name: "Bijapur",
                },
                {
                    id: "7",
                    name: "Bilaspur",
                },
                {
                    id: "8",
                    name: "Dantewada (South Bastar)",
                },
                {
                    id: "9",
                    name: "Dhamtari",
                },
                {
                    id: "10",
                    name: "Durg",
                },
                {
                    id: "11",
                    name: "Gariyaband",
                },
                {
                    id: "12",
                    name: "Janjgir-Champa",
                },
                {
                    id: "13",
                    name: "Jashpur",
                },
                {
                    id: "14",
                    name: "Kabirdham (Kawardha)",
                },
                {
                    id: "15",
                    name: "Kanker (North Bastar)",
                },
                {
                    id: "16",
                    name: "Kondagaon",
                },
                {
                    id: "17",
                    name: "Korba",
                },
                {
                    id: "18",
                    name: "Korea (Koriya)",
                },
                {
                    id: "19",
                    name: "Mahasamund",
                },
                {
                    id: "20",
                    name: "Mungeli",
                },
                {
                    id: "21",
                    name: "Narayanpur",
                },
                {
                    id: "22",
                    name: "Raigarh",
                },
                {
                    id: "23",
                    name: "Raipur",
                },
                {
                    id: "24",
                    name: "Rajnandgaon",
                },
                {
                    id: "25",
                    name: "Sukma",
                },
                {
                    id: "26",
                    name: "Surajpur  ",
                },
                {
                    id: "27",
                    name: "Surguja",
                },
            ],
        },
        {
            id: "8",
            type: "Union Territory",
            capital: "Silvassa",
            code: "DH",
            name: "Dadra and Nagar Haveli",
            districts: [
                {
                    id: "1",
                    name: "Dadra & Nagar Haveli",
                },
            ],
        },
        {
            id: "9",
            type: "Union Territory",
            capital: "Daman",
            code: "DD",
            name: "Daman and Diu",
            districts: [
                {
                    id: "1",
                    name: "Daman",
                },
                {
                    id: "2",
                    name: "Diu",
                },
            ],
        },
        {
            id: "10",
            type: "National Capital Territory",
            capital: "New Delhi",
            code: "DL",
            name: "Delhi",
            districts: [
                {
                    id: "1",
                    name: "Central Delhi",
                },
                {
                    id: "2",
                    name: "East Delhi",
                },
                {
                    id: "3",
                    name: "New Delhi",
                },
                {
                    id: "4",
                    name: "North Delhi",
                },
                {
                    id: "5",
                    name: "North East  Delhi",
                },
                {
                    id: "6",
                    name: "North West  Delhi",
                },
                {
                    id: "7",
                    name: "Shahdara",
                },
                {
                    id: "8",
                    name: "South Delhi",
                },
                {
                    id: "9",
                    name: "South East Delhi",
                },
                {
                    id: "10",
                    name: "South West  Delhi",
                },
                {
                    id: "11",
                    name: "West Delhi",
                },
            ],
        },
        {
            id: "11",
            type: "State",
            capital: "Panaji",
            code: "GA",
            name: "Goa",
            districts: [
                {
                    id: "1",
                    name: "North Goa",
                },
                {
                    id: "2",
                    name: "South Goa",
                },
            ],
        },
        {
            id: "12",
            type: "State",
            capital: "Gandhinagar",
            code: "GJ",
            name: "Gujarat",
            districts: [
                {
                    id: "1",
                    name: "Ahmedabad",
                },
                {
                    id: "2",
                    name: "Amreli",
                },
                {
                    id: "3",
                    name: "Anand",
                },
                {
                    id: "4",
                    name: "Aravalli",
                },
                {
                    id: "5",
                    name: "Banaskantha (Palanpur)",
                },
                {
                    id: "6",
                    name: "Bharuch",
                },
                {
                    id: "7",
                    name: "Bhavnagar",
                },
                {
                    id: "8",
                    name: "Botad",
                },
                {
                    id: "9",
                    name: "Chhota Udepur",
                },
                {
                    id: "10",
                    name: "Dahod",
                },
                {
                    id: "11",
                    name: "Dangs (Ahwa)",
                },
                {
                    id: "12",
                    name: "Devbhoomi Dwarka",
                },
                {
                    id: "13",
                    name: "Gandhinagar",
                },
                {
                    id: "14",
                    name: "Gir Somnath",
                },
                {
                    id: "15",
                    name: "Jamnagar",
                },
                {
                    id: "16",
                    name: "Junagadh",
                },
                {
                    id: "17",
                    name: "Kachchh",
                },
                {
                    id: "18",
                    name: "Kheda (Nadiad)",
                },
                {
                    id: "19",
                    name: "Mahisagar",
                },
                {
                    id: "20",
                    name: "Mehsana",
                },
                {
                    id: "21",
                    name: "Morbi",
                },
                {
                    id: "22",
                    name: "Narmada (Rajpipla)",
                },
                {
                    id: "23",
                    name: "Navsari",
                },
                {
                    id: "24",
                    name: "Panchmahal (Godhra)",
                },
                {
                    id: "25",
                    name: "Patan",
                },
                {
                    id: "26",
                    name: "Porbandar",
                },
                {
                    id: "27",
                    name: "Rajkot",
                },
                {
                    id: "28",
                    name: "Sabarkantha (Himmatnagar)",
                },
                {
                    id: "29",
                    name: "Surat",
                },
                {
                    id: "30",
                    name: "Surendranagar",
                },
                {
                    id: "31",
                    name: "Tapi (Vyara)",
                },
                {
                    id: "32",
                    name: "Vadodara",
                },
                {
                    id: "33",
                    name: "Valsad",
                },
            ],
        },
        {
            id: "13",
            type: "State",
            capital: "Chandigarh",
            code: "HR",
            name: "Haryana",
            districts: [
                {
                    id: "1",
                    name: "Ambala",
                },
                {
                    id: "2",
                    name: "Bhiwani",
                },
                {
                    id: "3",
                    name: "Charkhi Dadri",
                },
                {
                    id: "4",
                    name: "Faridabad",
                },
                {
                    id: "5",
                    name: "Fatehabad",
                },
                {
                    id: "6",
                    name: "Gurgaon",
                },
                {
                    id: "7",
                    name: "Hisar",
                },
                {
                    id: "8",
                    name: "Jhajjar",
                },
                {
                    id: "9",
                    name: "Jind",
                },
                {
                    id: "10",
                    name: "Kaithal",
                },
                {
                    id: "11",
                    name: "Karnal",
                },
                {
                    id: "12",
                    name: "Kurukshetra",
                },
                {
                    id: "13",
                    name: "Mahendragarh",
                },
                {
                    id: "14",
                    name: "Mewat",
                },
                {
                    id: "15",
                    name: "Palwal",
                },
                {
                    id: "16",
                    name: "Panchkula",
                },
                {
                    id: "17",
                    name: "Panipat",
                },
                {
                    id: "18",
                    name: "Rewari",
                },
                {
                    id: "19",
                    name: "Rohtak",
                },
                {
                    id: "20",
                    name: "Sirsa",
                },
                {
                    id: "21",
                    name: "Sonipat",
                },
                {
                    id: "22",
                    name: "Yamunanagar",
                },
            ],
        },
        {
            id: "14",
            type: "State",
            capital: "Shimla",
            code: "HP",
            name: "Himachal Pradesh",
            districts: [
                {
                    id: "1",
                    name: "Bilaspur",
                },
                {
                    id: "2",
                    name: "Chamba",
                },
                {
                    id: "3",
                    name: "Hamirpur",
                },
                {
                    id: "4",
                    name: "Kangra",
                },
                {
                    id: "5",
                    name: "Kinnaur",
                },
                {
                    id: "6",
                    name: "Kullu",
                },
                {
                    id: "7",
                    name: "Lahaul &amp; Spiti",
                },
                {
                    id: "8",
                    name: "Mandi",
                },
                {
                    id: "9",
                    name: "Shimla",
                },
                {
                    id: "10",
                    name: "Sirmaur (Sirmour)",
                },
                {
                    id: "11",
                    name: "Solan",
                },
                {
                    id: "12",
                    name: "Una",
                },
            ],
        },
        {
            id: "15",
            type: "Union Territory",
            capital: "Jammu (Winter), Srinagar (Summer)",
            code: "JK",
            name: "Jammu and Kashmir",
            districts: [
                {
                    id: "1",
                    name: "Anantnag",
                },
                {
                    id: "2",
                    name: "Bandipore",
                },
                {
                    id: "3",
                    name: "Baramulla",
                },
                {
                    id: "4",
                    name: "Budgam",
                },
                {
                    id: "5",
                    name: "Doda",
                },
                {
                    id: "6",
                    name: "Ganderbal",
                },
                {
                    id: "7",
                    name: "Jammu",
                },
                {
                    id: "8",
                    name: "Kargil",
                },
                {
                    id: "9",
                    name: "Kathua",
                },
                {
                    id: "10",
                    name: "Kishtwar",
                },
                {
                    id: "11",
                    name: "Kulgam",
                },
                {
                    id: "12",
                    name: "Kupwara",
                },
                {
                    id: "13",
                    name: "Leh",
                },
                {
                    id: "14",
                    name: "Poonch",
                },
                {
                    id: "15",
                    name: "Pulwama",
                },
                {
                    id: "16",
                    name: "Rajouri",
                },
                {
                    id: "17",
                    name: "Ramban",
                },
                {
                    id: "18",
                    name: "Reasi",
                },
                {
                    id: "19",
                    name: "Samba",
                },
                {
                    id: "20",
                    name: "Shopian",
                },
                {
                    id: "21",
                    name: "Srinagar",
                },
                {
                    id: "22",
                    name: "Udhampur",
                },
            ],
        },
        {
            id: "16",
            type: "State",
            capital: "Ranchi",
            code: "JH",
            name: "Jharkhand",
            districts: [
                {
                    id: "1",
                    name: "Bokaro",
                },
                {
                    id: "2",
                    name: "Chatra",
                },
                {
                    id: "3",
                    name: "Deoghar",
                },
                {
                    id: "4",
                    name: "Dhanbad",
                },
                {
                    id: "5",
                    name: "Dumka",
                },
                {
                    id: "6",
                    name: "East Singhbhum",
                },
                {
                    id: "7",
                    name: "Garhwa",
                },
                {
                    id: "8",
                    name: "Giridih",
                },
                {
                    id: "9",
                    name: "Godda",
                },
                {
                    id: "10",
                    name: "Gumla",
                },
                {
                    id: "11",
                    name: "Hazaribag",
                },
                {
                    id: "12",
                    name: "Jamtara",
                },
                {
                    id: "13",
                    name: "Khunti",
                },
                {
                    id: "14",
                    name: "Koderma",
                },
                {
                    id: "15",
                    name: "Latehar",
                },
                {
                    id: "16",
                    name: "Lohardaga",
                },
                {
                    id: "17",
                    name: "Pakur",
                },
                {
                    id: "18",
                    name: "Palamu",
                },
                {
                    id: "19",
                    name: "Ramgarh",
                },
                {
                    id: "20",
                    name: "Ranchi",
                },
                {
                    id: "21",
                    name: "Sahibganj",
                },
                {
                    id: "22",
                    name: "Seraikela-Kharsawan",
                },
                {
                    id: "23",
                    name: "Simdega",
                },
                {
                    id: "24",
                    name: "West Singhbhum",
                },
            ],
        },
        {
            id: "17",
            type: "State",
            capital: "Bengaluru",
            code: "KA",
            name: "Karnataka",
            districts: [
                {
                    id: "1",
                    name: "Bagalkot",
                },
                {
                    id: "2",
                    name: "Ballari ",
                },
                {
                    id: "3",
                    name: "Belagavi",
                },
                {
                    id: "4",
                    name: "Bengaluru Rural",
                },
                {
                    id: "5",
                    name: "Bengaluru Urban",
                },
                {
                    id: "6",
                    name: "Bidar",
                },
                {
                    id: "7",
                    name: "Chamarajanagar",
                },
                {
                    id: "8",
                    name: "Chikballapur",
                },
                {
                    id: "9",
                    name: "Chikkamagaluru",
                },
                {
                    id: "10",
                    name: "Chitradurga",
                },
                {
                    id: "11",
                    name: "Dakshina Kannada",
                },
                {
                    id: "12",
                    name: "Davangere",
                },
                {
                    id: "13",
                    name: "Dharwad",
                },
                {
                    id: "14",
                    name: "Gadag",
                },
                {
                    id: "15",
                    name: "Hassan",
                },
                {
                    id: "16",
                    name: "Haveri",
                },
                {
                    id: "17",
                    name: "Kalaburagi",
                },
                {
                    id: "18",
                    name: "Kodagu",
                },
                {
                    id: "19",
                    name: "Kolar",
                },
                {
                    id: "20",
                    name: "Koppal",
                },
                {
                    id: "21",
                    name: "Mandya",
                },
                {
                    id: "22",
                    name: "Mysuru",
                },
                {
                    id: "23",
                    name: "Raichur",
                },
                {
                    id: "24",
                    name: "Ramanagara",
                },
                {
                    id: "25",
                    name: "Shivamogga",
                },
                {
                    id: "26",
                    name: "Tumakuru",
                },
                {
                    id: "27",
                    name: "Udupi",
                },
                {
                    id: "28",
                    name: "Uttara Kannada (Karwar)",
                },
                {
                    id: "29",
                    name: "Vijayapura",
                },
                {
                    id: "30",
                    name: "Yadgir",
                },
            ],
        },
        {
            id: "18",
            type: "State",
            capital: "Thiruvananthapuram",
            code: "KL",
            name: "Kerala",
            districts: [
                {
                    id: "1",
                    name: "Alappuzha",
                },
                {
                    id: "2",
                    name: "Ernakulam",
                },
                {
                    id: "3",
                    name: "Idukki",
                },
                {
                    id: "4",
                    name: "Kannur",
                },
                {
                    id: "5",
                    name: "Kasaragod",
                },
                {
                    id: "6",
                    name: "Kollam",
                },
                {
                    id: "7",
                    name: "Kottayam",
                },
                {
                    id: "8",
                    name: "Kozhikode",
                },
                {
                    id: "9",
                    name: "Malappuram",
                },
                {
                    id: "10",
                    name: "Palakkad",
                },
                {
                    id: "11",
                    name: "Pathanamthitta",
                },
                {
                    id: "12",
                    name: "Thiruvananthapuram",
                },
                {
                    id: "13",
                    name: "Thrissur",
                },
                {
                    id: "14",
                    name: "Wayanad",
                },
            ],
        },
        {
            id: "19",
            type: "Union Territory",
            capital: "Leh, Kargil",
            code: "LA",
            name: "Ladakh",
            districts: [
                {
                    id: "1",
                    name: "Kargil",
                },
                {
                    id: "2",
                    name: "Leh",
                },
            ],
        },
        {
            id: "20",
            type: "Union Territory",
            capital: "Kavaratti",
            code: "LD",
            name: "Lakshadweep",
            districts: [
                {
                    id: "1",
                    name: "Agatti",
                },
                {
                    id: "2",
                    name: "Amini",
                },
                {
                    id: "3",
                    name: "Androth",
                },
                {
                    id: "4",
                    name: "Bithra",
                },
                {
                    id: "5",
                    name: "Chethlath",
                },
                {
                    id: "6",
                    name: "Kavaratti",
                },
                {
                    id: "7",
                    name: "Kadmath",
                },
                {
                    id: "8",
                    name: "Kalpeni",
                },
                {
                    id: "9",
                    name: "Kilthan",
                },
                {
                    id: "10",
                    name: "Minicoy",
                },
            ],
        },
        {
            id: "21",
            type: "State",
            capital: "Bhopal",
            code: "MP",
            name: "Madhya Pradesh",
            districts: [
                {
                    id: "1",
                    name: "Agar Malwa",
                },
                {
                    id: "2",
                    name: "Alirajpur",
                },
                {
                    id: "3",
                    name: "Anuppur",
                },
                {
                    id: "4",
                    name: "Ashoknagar",
                },
                {
                    id: "5",
                    name: "Balaghat",
                },
                {
                    id: "6",
                    name: "Barwani",
                },
                {
                    id: "7",
                    name: "Betul",
                },
                {
                    id: "8",
                    name: "Bhind",
                },
                {
                    id: "9",
                    name: "Bhopal",
                },
                {
                    id: "10",
                    name: "Burhanpur",
                },
                {
                    id: "11",
                    name: "Chhatarpur",
                },
                {
                    id: "12",
                    name: "Chhindwara",
                },
                {
                    id: "13",
                    name: "Damoh",
                },
                {
                    id: "14",
                    name: "Datia",
                },
                {
                    id: "15",
                    name: "Dewas",
                },
                {
                    id: "16",
                    name: "Dhar",
                },
                {
                    id: "17",
                    name: "Dindori",
                },
                {
                    id: "18",
                    name: "Guna",
                },
                {
                    id: "19",
                    name: "Gwalior",
                },
                {
                    id: "20",
                    name: "Harda",
                },
                {
                    id: "21",
                    name: "Hoshangabad",
                },
                {
                    id: "22",
                    name: "Indore",
                },
                {
                    id: "23",
                    name: "Jabalpur",
                },
                {
                    id: "24",
                    name: "Jhabua",
                },
                {
                    id: "25",
                    name: "Katni",
                },
                {
                    id: "26",
                    name: "Khandwa",
                },
                {
                    id: "27",
                    name: "Khargone",
                },
                {
                    id: "28",
                    name: "Mandla",
                },
                {
                    id: "29",
                    name: "Mandsaur",
                },
                {
                    id: "30",
                    name: "Morena",
                },
                {
                    id: "31",
                    name: "Narsinghpur",
                },
                {
                    id: "32",
                    name: "Neemuch",
                },
                {
                    id: "33",
                    name: "Panna",
                },
                {
                    id: "34",
                    name: "Raisen",
                },
                {
                    id: "35",
                    name: "Rajgarh",
                },
                {
                    id: "36",
                    name: "Ratlam",
                },
                {
                    id: "37",
                    name: "Rewa",
                },
                {
                    id: "38",
                    name: "Sagar",
                },
                {
                    id: "39",
                    name: "Satna",
                },
                {
                    id: "40",
                    name: "Sehore",
                },
                {
                    id: "41",
                    name: "Seoni",
                },
                {
                    id: "42",
                    name: "Shahdol",
                },
                {
                    id: "43",
                    name: "Shajapur",
                },
                {
                    id: "44",
                    name: "Sheopur",
                },
                {
                    id: "45",
                    name: "Shivpuri",
                },
                {
                    id: "46",
                    name: "Sidhi",
                },
                {
                    id: "47",
                    name: "Singrauli",
                },
                {
                    id: "48",
                    name: "Tikamgarh",
                },
                {
                    id: "49",
                    name: "Ujjain",
                },
                {
                    id: "50",
                    name: "Umaria",
                },
                {
                    id: "51",
                    name: "Vidisha",
                },
            ],
        },
        {
            id: "22",
            type: "State",
            capital: "Mumbai",
            code: "MH",
            name: "Maharashtra",
            districts: [
                {
                    id: "1",
                    name: "Ahmednagar",
                },
                {
                    id: "2",
                    name: "Akola",
                },
                {
                    id: "3",
                    name: "Amravati",
                },
                {
                    id: "4",
                    name: "Aurangabad",
                },
                {
                    id: "5",
                    name: "Beed",
                },
                {
                    id: "6",
                    name: "Bhandara",
                },
                {
                    id: "7",
                    name: "Buldhana",
                },
                {
                    id: "8",
                    name: "Chandrapur",
                },
                {
                    id: "9",
                    name: "Dhule",
                },
                {
                    id: "10",
                    name: "Gadchiroli",
                },
                {
                    id: "11",
                    name: "Gondia",
                },
                {
                    id: "12",
                    name: "Hingoli",
                },
                {
                    id: "13",
                    name: "Jalgaon",
                },
                {
                    id: "14",
                    name: "Jalna",
                },
                {
                    id: "15",
                    name: "Kolhapur",
                },
                {
                    id: "16",
                    name: "Latur",
                },
                {
                    id: "17",
                    name: "Mumbai City",
                },
                {
                    id: "18",
                    name: "Mumbai Suburban",
                },
                {
                    id: "19",
                    name: "Nagpur",
                },
                {
                    id: "20",
                    name: "Nanded",
                },
                {
                    id: "21",
                    name: "Nandurbar",
                },
                {
                    id: "22",
                    name: "Nashik",
                },
                {
                    id: "23",
                    name: "Osmanabad",
                },
                {
                    id: "24",
                    name: "Palghar",
                },
                {
                    id: "25",
                    name: "Parbhani",
                },
                {
                    id: "26",
                    name: "Pune",
                },
                {
                    id: "27",
                    name: "Raigad",
                },
                {
                    id: "28",
                    name: "Ratnagiri",
                },
                {
                    id: "29",
                    name: "Sangli",
                },
                {
                    id: "30",
                    name: "Satara",
                },
                {
                    id: "31",
                    name: "Sindhudurg",
                },
                {
                    id: "32",
                    name: "Solapur",
                },
                {
                    id: "33",
                    name: "Thane",
                },
                {
                    id: "34",
                    name: "Wardha",
                },
                {
                    id: "35",
                    name: "Washim",
                },
                {
                    id: "36",
                    name: "Yavatmal",
                },
            ],
        },
        {
            id: "23",
            type: "State",
            capital: "Imphal",
            code: "MN",
            name: "Manipur",
            districts: [
                {
                    id: "1",
                    name: "Bishnupur",
                },
                {
                    id: "2",
                    name: "Chandel",
                },
                {
                    id: "3",
                    name: "Churachandpur",
                },
                {
                    id: "4",
                    name: "Imphal East",
                },
                {
                    id: "5",
                    name: "Imphal West",
                },
                {
                    id: "6",
                    name: "Jiribam",
                },
                {
                    id: "7",
                    name: "Kakching",
                },
                {
                    id: "8",
                    name: "Kamjong",
                },
                {
                    id: "9",
                    name: "Kangpokpi",
                },
                {
                    id: "10",
                    name: "Noney",
                },
                {
                    id: "11",
                    name: "Pherzawl",
                },
                {
                    id: "12",
                    name: "Senapati",
                },
                {
                    id: "13",
                    name: "Tamenglong",
                },
                {
                    id: "14",
                    name: "Tengnoupal",
                },
                {
                    id: "15",
                    name: "Thoubal",
                },
                {
                    id: "16",
                    name: "Ukhrul",
                },
            ],
        },
        {
            id: "24",
            type: "State",
            capital: "Shillong",
            code: "ML",
            name: "Meghalaya",
            districts: [
                {
                    id: "1",
                    name: "East Garo Hills",
                },
                {
                    id: "2",
                    name: "East Jaintia Hills",
                },
                {
                    id: "3",
                    name: "East Khasi Hills",
                },
                {
                    id: "4",
                    name: "North Garo Hills",
                },
                {
                    id: "5",
                    name: "Ri Bhoi",
                },
                {
                    id: "6",
                    name: "South Garo Hills",
                },
                {
                    id: "7",
                    name: "South West Garo Hills ",
                },
                {
                    id: "8",
                    name: "South West Khasi Hills",
                },
                {
                    id: "9",
                    name: "West Garo Hills",
                },
                {
                    id: "10",
                    name: "West Jaintia Hills",
                },
                {
                    id: "11",
                    name: "West Khasi Hills",
                },
            ],
        },
        {
            id: "25",
            type: "State",
            capital: "Aizawl",
            code: "MZ",
            name: "Mizoram",
            districts: [
                {
                    id: "1",
                    name: "Aizawl",
                },
                {
                    id: "2",
                    name: "Champhai",
                },
                {
                    id: "3",
                    name: "Kolasib",
                },
                {
                    id: "4",
                    name: "Lawngtlai",
                },
                {
                    id: "5",
                    name: "Lunglei",
                },
                {
                    id: "6",
                    name: "Mamit",
                },
                {
                    id: "7",
                    name: "Saiha",
                },
                {
                    id: "8",
                    name: "Serchhip",
                },
            ],
        },
        {
            id: "26",
            type: "State",
            capital: "Kohima",
            code: "NL",
            name: "Nagaland",
            districts: [
                {
                    id: "1",
                    name: "Dimapur",
                },
                {
                    id: "2",
                    name: "Kiphire",
                },
                {
                    id: "3",
                    name: "Kohima",
                },
                {
                    id: "4",
                    name: "Longleng",
                },
                {
                    id: "5",
                    name: "Mokokchung",
                },
                {
                    id: "6",
                    name: "Mon",
                },
                {
                    id: "7",
                    name: "Peren",
                },
                {
                    id: "8",
                    name: "Phek",
                },
                {
                    id: "9",
                    name: "Tuensang",
                },
                {
                    id: "10",
                    name: "Wokha",
                },
                {
                    id: "11",
                    name: "Zunheboto",
                },
            ],
        },
        {
            id: "27",
            type: "State",
            capital: "Bhubaneswar",
            code: "OR",
            name: "Odisha",
            districts: [
                {
                    id: "1",
                    name: "Angul",
                },
                {
                    id: "2",
                    name: "Balangir",
                },
                {
                    id: "3",
                    name: "Balasore",
                },
                {
                    id: "4",
                    name: "Bargarh",
                },
                {
                    id: "5",
                    name: "Bhadrak",
                },
                {
                    id: "6",
                    name: "Boudh",
                },
                {
                    id: "7",
                    name: "Cuttack",
                },
                {
                    id: "8",
                    name: "Deogarh",
                },
                {
                    id: "9",
                    name: "Dhenkanal",
                },
                {
                    id: "10",
                    name: "Gajapati",
                },
                {
                    id: "11",
                    name: "Ganjam",
                },
                {
                    id: "12",
                    name: "Jagatsinghapur",
                },
                {
                    id: "13",
                    name: "Jajpur",
                },
                {
                    id: "14",
                    name: "Jharsuguda",
                },
                {
                    id: "15",
                    name: "Kalahandi",
                },
                {
                    id: "16",
                    name: "Kandhamal",
                },
                {
                    id: "17",
                    name: "Kendrapara",
                },
                {
                    id: "18",
                    name: "Kendujhar (Keonjhar)",
                },
                {
                    id: "19",
                    name: "Khordha",
                },
                {
                    id: "20",
                    name: "Koraput",
                },
                {
                    id: "21",
                    name: "Malkangiri",
                },
                {
                    id: "22",
                    name: "Mayurbhanj",
                },
                {
                    id: "23",
                    name: "Nabarangpur",
                },
                {
                    id: "24",
                    name: "Nayagarh",
                },
                {
                    id: "25",
                    name: "Nuapada",
                },
                {
                    id: "26",
                    name: "Puri",
                },
                {
                    id: "27",
                    name: "Rayagada",
                },
                {
                    id: "28",
                    name: "Sambalpur",
                },
                {
                    id: "29",
                    name: "Sonepur",
                },
                {
                    id: "30",
                    name: "Sundargarh",
                },
            ],
        },
        {
            id: "28",
            type: "Union Territory",
            capital: "Puducherry",
            code: "PY",
            name: "Puducherry",
            districts: [
                {
                    id: "1",
                    name: "Karaikal",
                },
                {
                    id: "2",
                    name: "Mahe",
                },
                {
                    id: "3",
                    name: "Pondicherry",
                },
                {
                    id: "4",
                    name: "Yanam",
                },
            ],
        },
        {
            id: "29",
            type: "State",
            capital: "Chandigarh",
            code: "PB",
            name: "Punjab",
            districts: [
                {
                    id: "1",
                    name: "Amritsar",
                },
                {
                    id: "2",
                    name: "Barnala",
                },
                {
                    id: "3",
                    name: "Bathinda",
                },
                {
                    id: "4",
                    name: "Faridkot",
                },
                {
                    id: "5",
                    name: "Fatehgarh Sahib",
                },
                {
                    id: "6",
                    name: "Fazilka",
                },
                {
                    id: "7",
                    name: "Ferozepur",
                },
                {
                    id: "8",
                    name: "Gurdaspur",
                },
                {
                    id: "9",
                    name: "Hoshiarpur",
                },
                {
                    id: "10",
                    name: "Jalandhar",
                },
                {
                    id: "11",
                    name: "Kapurthala",
                },
                {
                    id: "12",
                    name: "Ludhiana",
                },
                {
                    id: "13",
                    name: "Mansa",
                },
                {
                    id: "14",
                    name: "Moga",
                },
                {
                    id: "15",
                    name: "Muktsar",
                },
                {
                    id: "16",
                    name: "Nawanshahr (Shahid Bhagat Singh Nagar)",
                },
                {
                    id: "17",
                    name: "Pathankot",
                },
                {
                    id: "18",
                    name: "Patiala",
                },
                {
                    id: "19",
                    name: "Rupnagar",
                },
                {
                    id: "20",
                    name: "Sahibzada Ajit Singh Nagar (Mohali)",
                },
                {
                    id: "21",
                    name: "Sangrur",
                },
                {
                    id: "22",
                    name: "Tarn Taran",
                },
            ],
        },
        {
            id: "30",
            type: "State",
            capital: "Jaipur",
            code: "RJ",
            name: "Rajasthan",
            districts: [
                {
                    id: "1",
                    name: "Ajmer",
                },
                {
                    id: "2",
                    name: "Alwar",
                },
                {
                    id: "3",
                    name: "Banswara",
                },
                {
                    id: "4",
                    name: "Baran",
                },
                {
                    id: "5",
                    name: "Barmer",
                },
                {
                    id: "6",
                    name: "Bharatpur",
                },
                {
                    id: "7",
                    name: "Bhilwara",
                },
                {
                    id: "8",
                    name: "Bikaner",
                },
                {
                    id: "9",
                    name: "Bundi",
                },
                {
                    id: "10",
                    name: "Chittorgarh",
                },
                {
                    id: "11",
                    name: "Churu",
                },
                {
                    id: "12",
                    name: "Dausa",
                },
                {
                    id: "13",
                    name: "Dholpur",
                },
                {
                    id: "14",
                    name: "Dungarpur",
                },
                {
                    id: "15",
                    name: "Hanumangarh",
                },
                {
                    id: "16",
                    name: "Jaipur",
                },
                {
                    id: "17",
                    name: "Jaisalmer",
                },
                {
                    id: "18",
                    name: "Jalore",
                },
                {
                    id: "19",
                    name: "Jhalawar",
                },
                {
                    id: "20",
                    name: "Jhunjhunu",
                },
                {
                    id: "21",
                    name: "Jodhpur",
                },
                {
                    id: "22",
                    name: "Karauli",
                },
                {
                    id: "23",
                    name: "Kota",
                },
                {
                    id: "24",
                    name: "Nagaur",
                },
                {
                    id: "25",
                    name: "Pali",
                },
                {
                    id: "26",
                    name: "Pratapgarh",
                },
                {
                    id: "27",
                    name: "Rajsamand",
                },
                {
                    id: "28",
                    name: "Sawai Madhopur",
                },
                {
                    id: "29",
                    name: "Sikar",
                },
                {
                    id: "30",
                    name: "Sirohi",
                },
                {
                    id: "31",
                    name: "Sri Ganganagar",
                },
                {
                    id: "32",
                    name: "Tonk",
                },
                {
                    id: "33",
                    name: "Udaipur",
                },
            ],
        },
        {
            id: "31",
            type: "State",
            capital: "Gangtok",
            code: "SK",
            name: "Sikkim",
            districts: [
                {
                    id: "1",
                    name: "East Sikkim",
                },
                {
                    id: "2",
                    name: "North Sikkim",
                },
                {
                    id: "3",
                    name: "South Sikkim",
                },
                {
                    id: "4",
                    name: "West Sikkim",
                },
            ],
        },
        {
            id: "32",
            type: "State",
            capital: "Chennai",
            code: "TN",
            name: "Tamil Nadu",
            districts: [
                {
                    id: "1",
                    name: "Ariyalur",
                },
                {
                    id: "2",
                    name: "Chennai",
                },
                {
                    id: "3",
                    name: "Coimbatore",
                },
                {
                    id: "4",
                    name: "Cuddalore",
                },
                {
                    id: "5",
                    name: "Dharmapuri",
                },
                {
                    id: "6",
                    name: "Dindigul",
                },
                {
                    id: "7",
                    name: "Erode",
                },
                {
                    id: "8",
                    name: "Kanchipuram",
                },
                {
                    id: "9",
                    name: "Kanyakumari",
                },
                {
                    id: "10",
                    name: "Karur",
                },
                {
                    id: "11",
                    name: "Krishnagiri",
                },
                {
                    id: "12",
                    name: "Madurai",
                },
                {
                    id: "13",
                    name: "Nagapattinam",
                },
                {
                    id: "14",
                    name: "Namakkal",
                },
                {
                    id: "15",
                    name: "Nilgiris",
                },
                {
                    id: "16",
                    name: "Perambalur",
                },
                {
                    id: "17",
                    name: "Pudukkottai",
                },
                {
                    id: "18",
                    name: "Ramanathapuram",
                },
                {
                    id: "19",
                    name: "Salem",
                },
                {
                    id: "20",
                    name: "Sivaganga",
                },
                {
                    id: "21",
                    name: "Thanjavur",
                },
                {
                    id: "22",
                    name: "Theni",
                },
                {
                    id: "23",
                    name: "Thoothukudi (Tuticorin)",
                },
                {
                    id: "24",
                    name: "Tiruchirappalli",
                },
                {
                    id: "25",
                    name: "Tirunelveli",
                },
                {
                    id: "26",
                    name: "Tiruppur",
                },
                {
                    id: "27",
                    name: "Tiruvallur",
                },
                {
                    id: "28",
                    name: "Tiruvannamalai",
                },
                {
                    id: "29",
                    name: "Tiruvarur",
                },
                {
                    id: "30",
                    name: "Vellore",
                },
                {
                    id: "31",
                    name: "Viluppuram",
                },
                {
                    id: "32",
                    name: "Virudhunagar",
                },
            ],
        },
        {
            id: "33",
            type: "State",
            capital: "Hyderabad",
            code: "TS",
            name: "Telangana",
            districts: [
                {
                    id: "1",
                    name: "Adilabad",
                },
                {
                    id: "2",
                    name: "Bhadradri Kothagudem",
                },
                {
                    id: "3",
                    name: "Hyderabad",
                },
                {
                    id: "4",
                    name: "Jagtial",
                },
                {
                    id: "5",
                    name: "Jangaon",
                },
                {
                    id: "6",
                    name: "Jayashankar Bhoopalpally",
                },
                {
                    id: "7",
                    name: "Jogulamba Gadwal",
                },
                {
                    id: "8",
                    name: "Kamareddy",
                },
                {
                    id: "9",
                    name: "Karimnagar",
                },
                {
                    id: "10",
                    name: "Khammam",
                },
                {
                    id: "11",
                    name: "Komaram Bheem Asifabad",
                },
                {
                    id: "12",
                    name: "Mahabubabad",
                },
                {
                    id: "13",
                    name: "Mahabubnagar",
                },
                {
                    id: "14",
                    name: "Mancherial",
                },
                {
                    id: "15",
                    name: "Medak",
                },
                {
                    id: "16",
                    name: "Medchal",
                },
                {
                    id: "17",
                    name: "Nagarkurnool",
                },
                {
                    id: "18",
                    name: "Nalgonda",
                },
                {
                    id: "19",
                    name: "Nirmal",
                },
                {
                    id: "20",
                    name: "Nizamabad",
                },
                {
                    id: "21",
                    name: "Peddapalli",
                },
                {
                    id: "22",
                    name: "Rajanna Sircilla",
                },
                {
                    id: "23",
                    name: "Rangareddy",
                },
                {
                    id: "24",
                    name: "Sangareddy",
                },
                {
                    id: "25",
                    name: "Siddipet",
                },
                {
                    id: "26",
                    name: "Suryapet",
                },
                {
                    id: "27",
                    name: "Vikarabad",
                },
                {
                    id: "28",
                    name: "Wanaparthy",
                },
                {
                    id: "29",
                    name: "Warangal (Rural)",
                },
                {
                    id: "30",
                    name: "Warangal (Urban)",
                },
                {
                    id: "31",
                    name: "Yadadri Bhuvanagiri",
                },
            ],
        },
        {
            id: "34",
            type: "State",
            capital: "Agartala",
            code: "TR",
            name: "Tripura",
            districts: [
                {
                    id: "1",
                    name: "Dhalai",
                },
                {
                    id: "2",
                    name: "Gomati",
                },
                {
                    id: "3",
                    name: "Khowai",
                },
                {
                    id: "4",
                    name: "North Tripura",
                },
                {
                    id: "5",
                    name: "Sepahijala",
                },
                {
                    id: "6",
                    name: "South Tripura",
                },
                {
                    id: "7",
                    name: "Unakoti",
                },
                {
                    id: "8",
                    name: "West Tripura",
                },
            ],
        },
        {
            id: "35",
            type: "State",
            capital: "Lucknow",
            code: "UP",
            name: "Uttar Pradesh",
            districts: [
                {
                    id: "1",
                    name: "Agra",
                },
                {
                    id: "2",
                    name: "Aligarh",
                },
                {
                    id: "3",
                    name: "Allahabad",
                },
                {
                    id: "4",
                    name: "Ambedkar Nagar",
                },
                {
                    id: "5",
                    name: "Amethi (Chatrapati Sahuji Mahraj Nagar)",
                },
                {
                    id: "6",
                    name: "Amroha (J.P. Nagar)",
                },
                {
                    id: "7",
                    name: "Auraiya",
                },
                {
                    id: "8",
                    name: "Azamgarh",
                },
                {
                    id: "9",
                    name: "Baghpat",
                },
                {
                    id: "10",
                    name: "Bahraich",
                },
                {
                    id: "11",
                    name: "Ballia",
                },
                {
                    id: "12",
                    name: "Balrampur",
                },
                {
                    id: "13",
                    name: "Banda",
                },
                {
                    id: "14",
                    name: "Barabanki",
                },
                {
                    id: "15",
                    name: "Bareilly",
                },
                {
                    id: "16",
                    name: "Basti",
                },
                {
                    id: "17",
                    name: "Bhadohi",
                },
                {
                    id: "18",
                    name: "Bijnor",
                },
                {
                    id: "19",
                    name: "Budaun",
                },
                {
                    id: "20",
                    name: "Bulandshahr",
                },
                {
                    id: "21",
                    name: "Chandauli",
                },
                {
                    id: "22",
                    name: "Chitrakoot",
                },
                {
                    id: "23",
                    name: "Deoria",
                },
                {
                    id: "24",
                    name: "Etah",
                },
                {
                    id: "25",
                    name: "Etawah",
                },
                {
                    id: "26",
                    name: "Faizabad",
                },
                {
                    id: "27",
                    name: "Farrukhabad",
                },
                {
                    id: "28",
                    name: "Fatehpur",
                },
                {
                    id: "29",
                    name: "Firozabad",
                },
                {
                    id: "30",
                    name: "Gautam Buddha Nagar",
                },
                {
                    id: "31",
                    name: "Ghaziabad",
                },
                {
                    id: "32",
                    name: "Ghazipur",
                },
                {
                    id: "33",
                    name: "Gonda",
                },
                {
                    id: "34",
                    name: "Gorakhpur",
                },
                {
                    id: "35",
                    name: "Hamirpur",
                },
                {
                    id: "36",
                    name: "Hapur (Panchsheel Nagar)",
                },
                {
                    id: "37",
                    name: "Hardoi",
                },
                {
                    id: "38",
                    name: "Hathras",
                },
                {
                    id: "39",
                    name: "Jalaun",
                },
                {
                    id: "40",
                    name: "Jaunpur",
                },
                {
                    id: "41",
                    name: "Jhansi",
                },
                {
                    id: "42",
                    name: "Kannauj",
                },
                {
                    id: "43",
                    name: "Kanpur Dehat",
                },
                {
                    id: "44",
                    name: "Kanpur Nagar",
                },
                {
                    id: "45",
                    name: "Kanshiram Nagar (Kasganj)",
                },
                {
                    id: "46",
                    name: "Kaushambi",
                },
                {
                    id: "47",
                    name: "Kushinagar (Padrauna)",
                },
                {
                    id: "48",
                    name: "Lakhimpur - Kheri",
                },
                {
                    id: "49",
                    name: "Lalitpur",
                },
                {
                    id: "50",
                    name: "Lucknow",
                },
                {
                    id: "51",
                    name: "Maharajganj",
                },
                {
                    id: "52",
                    name: "Mahoba",
                },
                {
                    id: "53",
                    name: "Mainpuri",
                },
                {
                    id: "54",
                    name: "Mathura",
                },
                {
                    id: "55",
                    name: "Mau",
                },
                {
                    id: "56",
                    name: "Meerut",
                },
                {
                    id: "57",
                    name: "Mirzapur",
                },
                {
                    id: "58",
                    name: "Moradabad",
                },
                {
                    id: "59",
                    name: "Muzaffarnagar",
                },
                {
                    id: "60",
                    name: "Pilibhit",
                },
                {
                    id: "61",
                    name: "Pratapgarh",
                },
                {
                    id: "62",
                    name: "RaeBareli",
                },
                {
                    id: "63",
                    name: "Rampur",
                },
                {
                    id: "64",
                    name: "Saharanpur",
                },
                {
                    id: "65",
                    name: "Sambhal (Bhim Nagar)",
                },
                {
                    id: "66",
                    name: "Sant Kabir Nagar",
                },
                {
                    id: "67",
                    name: "Shahjahanpur",
                },
                {
                    id: "68",
                    name: "Shamali (Prabuddh Nagar)",
                },
                {
                    id: "69",
                    name: "Shravasti",
                },
                {
                    id: "70",
                    name: "Siddharth Nagar",
                },
                {
                    id: "71",
                    name: "Sitapur",
                },
                {
                    id: "72",
                    name: "Sonbhadra",
                },
                {
                    id: "73",
                    name: "Sultanpur",
                },
                {
                    id: "74",
                    name: "Unnao",
                },
                {
                    id: "75",
                    name: "Varanasi",
                },
            ],
        },
        {
            id: "36",
            type: "State",
            capital: "Dehradun",
            code: "UK",
            name: "Uttarakhand",
            districts: [
                {
                    id: "1",
                    name: "Almora",
                },
                {
                    id: "2",
                    name: "Bageshwar",
                },
                {
                    id: "3",
                    name: "Chamoli",
                },
                {
                    id: "4",
                    name: "Champawat",
                },
                {
                    id: "5",
                    name: "Dehradun",
                },
                {
                    id: "6",
                    name: "Haridwar",
                },
                {
                    id: "7",
                    name: "Nainital",
                },
                {
                    id: "8",
                    name: "Pauri Garhwal",
                },
                {
                    id: "9",
                    name: "Pithoragarh",
                },
                {
                    id: "10",
                    name: "Rudraprayag",
                },
                {
                    id: "11",
                    name: "Tehri Garhwal",
                },
                {
                    id: "12",
                    name: "Udham Singh Nagar",
                },
                {
                    id: "13",
                    name: "Uttarkashi",
                },
            ],
        },
        {
            id: "37",
            type: "State",
            capital: "Kolkata",
            code: "WB",
            name: "West Bengal",
            districts: [
                {
                    id: "1",
                    name: "Alipurduar",
                },
                {
                    id: "2",
                    name: "Bankura",
                },
                {
                    id: "3",
                    name: "Birbhum",
                },
                {
                    id: "4",
                    name: "Burdwan (Bardhaman)",
                },
                {
                    id: "5",
                    name: "Cooch Behar",
                },
                {
                    id: "6",
                    name: "Dakshin Dinajpur (South Dinajpur)",
                },
                {
                    id: "7",
                    name: "Darjeeling",
                },
                {
                    id: "8",
                    name: "Hooghly",
                },
                {
                    id: "9",
                    name: "Howrah",
                },
                {
                    id: "10",
                    name: "Jalpaiguri",
                },
                {
                    id: "11",
                    name: "Kalimpong",
                },
                {
                    id: "12",
                    name: "Kolkata",
                },
                {
                    id: "13",
                    name: "Malda",
                },
                {
                    id: "14",
                    name: "Murshidabad",
                },
                {
                    id: "15",
                    name: "Nadia",
                },
                {
                    id: "16",
                    name: "North 24 Parganas",
                },
                {
                    id: "17",
                    name: "Paschim Medinipur (West Medinipur)",
                },
                {
                    id: "18",
                    name: "Purba Medinipur (East Medinipur)",
                },
                {
                    id: "19",
                    name: "Purulia",
                },
                {
                    id: "20",
                    name: "South 24 Parganas",
                },
                {
                    id: "21",
                    name: "Uttar Dinajpur (North Dinajpur)",
                },
            ],
        },
    ],
};

export const currencyList = [
    { cc: "INR", symbol: "\u20B9", name: "Indian rupee" },
    { cc: "AED", symbol: "\u062f.\u0625;", name: "UAE dirham" },
    { cc: "AFN", symbol: "Afs", name: "Afghan afghani" },
    { cc: "ALL", symbol: "L", name: "Albanian lek" },
    { cc: "AMD", symbol: "AMD", name: "Armenian dram" },
    { cc: "ANG", symbol: "NA\u0192", name: "Netherlands Antillean gulden" },
    { cc: "AOA", symbol: "Kz", name: "Angolan kwanza" },
    { cc: "ARS", symbol: "$", name: "Argentine peso" },
    { cc: "AUD", symbol: "$", name: "Australian dollar" },
    { cc: "AWG", symbol: "\u0192", name: "Aruban florin" },
    { cc: "AZN", symbol: "AZN", name: "Azerbaijani manat" },
    {
        cc: "BAM",
        symbol: "KM",
        name: "Bosnia and Herzegovina konvertibilna marka",
    },
    { cc: "BBD", symbol: "Bds$", name: "Barbadian dollar" },
    { cc: "BDT", symbol: "\u09f3", name: "Bangladeshi taka" },
    { cc: "BGN", symbol: "BGN", name: "Bulgarian lev" },
    { cc: "BHD", symbol: ".\u062f.\u0628", name: "Bahraini dinar" },
    { cc: "BIF", symbol: "FBu", name: "Burundi franc" },
    { cc: "BMD", symbol: "BD$", name: "Bermudian dollar" },
    { cc: "BND", symbol: "B$", name: "Brunei dollar" },
    { cc: "BOB", symbol: "Bs.", name: "Bolivian boliviano" },
    { cc: "BRL", symbol: "R$", name: "Brazilian real" },
    { cc: "BSD", symbol: "B$", name: "Bahamian dollar" },
    { cc: "BTN", symbol: "Nu.", name: "Bhutanese ngultrum" },
    { cc: "BWP", symbol: "P", name: "Botswana pula" },
    { cc: "BYR", symbol: "Br", name: "Belarusian ruble" },
    { cc: "BZD", symbol: "BZ$", name: "Belize dollar" },
    { cc: "CAD", symbol: "$", name: "Canadian dollar" },
    { cc: "CDF", symbol: "F", name: "Congolese franc" },
    { cc: "CHF", symbol: "Fr.", name: "Swiss franc" },
    { cc: "CLP", symbol: "$", name: "Chilean peso" },
    { cc: "CNY", symbol: "\u00a5", name: "Chinese/Yuan renminbi" },
    { cc: "COP", symbol: "Col$", name: "Colombian peso" },
    { cc: "CRC", symbol: "\u20a1", name: "Costa Rican colon" },
    { cc: "CUC", symbol: "$", name: "Cuban peso" },
    { cc: "CVE", symbol: "Esc", name: "Cape Verdean escudo" },
    { cc: "CZK", symbol: "K\u010d", name: "Czech koruna" },
    { cc: "DJF", symbol: "Fdj", name: "Djiboutian franc" },
    { cc: "DKK", symbol: "Kr", name: "Danish krone" },
    { cc: "DOP", symbol: "RD$", name: "Dominican peso" },
    { cc: "DZD", symbol: "\u062f.\u062c", name: "Algerian dinar" },
    { cc: "EEK", symbol: "KR", name: "Estonian kroon" },
    { cc: "EGP", symbol: "\u00a3", name: "Egyptian pound" },
    { cc: "ERN", symbol: "Nfa", name: "Eritrean nakfa" },
    { cc: "ETB", symbol: "Br", name: "Ethiopian birr" },
    { cc: "EUR", symbol: "\u20ac", name: "European Euro" },
    { cc: "FJD", symbol: "FJ$", name: "Fijian dollar" },
    { cc: "FKP", symbol: "\u00a3", name: "Falkland Islands pound" },
    { cc: "GBP", symbol: "\u00a3", name: "British pound" },
    { cc: "GEL", symbol: "GEL", name: "Georgian lari" },
    { cc: "GHS", symbol: "GH\u20b5", name: "Ghanaian cedi" },
    { cc: "GIP", symbol: "\u00a3", name: "Gibraltar pound" },
    { cc: "GMD", symbol: "D", name: "Gambian dalasi" },
    { cc: "GNF", symbol: "FG", name: "Guinean franc" },
    { cc: "GQE", symbol: "CFA", name: "Central African CFA franc" },
    { cc: "GTQ", symbol: "Q", name: "Guatemalan quetzal" },
    { cc: "GYD", symbol: "GY$", name: "Guyanese dollar" },
    { cc: "HKD", symbol: "HK$", name: "Hong Kong dollar" },
    { cc: "HNL", symbol: "L", name: "Honduran lempira" },
    { cc: "HRK", symbol: "kn", name: "Croatian kuna" },
    { cc: "HTG", symbol: "G", name: "Haitian gourde" },
    { cc: "HUF", symbol: "Ft", name: "Hungarian forint" },
    { cc: "IDR", symbol: "Rp", name: "Indonesian rupiah" },
    { cc: "ILS", symbol: "\u20aa", name: "Israeli new sheqel" },

    { cc: "IQD", symbol: "\u062f.\u0639", name: "Iraqi dinar" },
    { cc: "IRR", symbol: "IRR", name: "Iranian rial" },
    { cc: "ISK", symbol: "kr", name: "Icelandic kr\u00f3na" },
    { cc: "JMD", symbol: "J$", name: "Jamaican dollar" },
    { cc: "JOD", symbol: "JOD", name: "Jordanian dinar" },
    { cc: "JPY", symbol: "\u00a5", name: "Japanese yen" },
    { cc: "KES", symbol: "KSh", name: "Kenyan shilling" },
    { cc: "KGS", symbol: "\u0441\u043e\u043c", name: "Kyrgyzstani som" },
    { cc: "KHR", symbol: "\u17db", name: "Cambodian riel" },
    { cc: "KMF", symbol: "KMF", name: "Comorian franc" },
    { cc: "KPW", symbol: "W", name: "North Korean won" },
    { cc: "KRW", symbol: "W", name: "South Korean won" },
    { cc: "KWD", symbol: "KWD", name: "Kuwaiti dinar" },
    { cc: "KYD", symbol: "KY$", name: "Cayman Islands dollar" },
    { cc: "KZT", symbol: "T", name: "Kazakhstani tenge" },
    { cc: "LAK", symbol: "KN", name: "Lao kip" },
    { cc: "LBP", symbol: "\u00a3", name: "Lebanese lira" },
    { cc: "LKR", symbol: "Rs", name: "Sri Lankan rupee" },
    { cc: "LRD", symbol: "L$", name: "Liberian dollar" },
    { cc: "LSL", symbol: "M", name: "Lesotho loti" },
    { cc: "LTL", symbol: "Lt", name: "Lithuanian litas" },
    { cc: "LVL", symbol: "Ls", name: "Latvian lats" },
    { cc: "LYD", symbol: "LD", name: "Libyan dinar" },
    { cc: "MAD", symbol: "MAD", name: "Moroccan dirham" },
    { cc: "MDL", symbol: "MDL", name: "Moldovan leu" },
    { cc: "MGA", symbol: "FMG", name: "Malagasy ariary" },
    { cc: "MKD", symbol: "MKD", name: "Macedonian denar" },
    { cc: "MMK", symbol: "K", name: "Myanma kyat" },
    { cc: "MNT", symbol: "\u20ae", name: "Mongolian tugrik" },
    { cc: "MOP", symbol: "P", name: "Macanese pataca" },
    { cc: "MRO", symbol: "UM", name: "Mauritanian ouguiya" },
    { cc: "MUR", symbol: "Rs", name: "Mauritian rupee" },
    { cc: "MVR", symbol: "Rf", name: "Maldivian rufiyaa" },
    { cc: "MWK", symbol: "MK", name: "Malawian kwacha" },
    { cc: "MXN", symbol: "$", name: "Mexican peso" },
    { cc: "MYR", symbol: "RM", name: "Malaysian ringgit" },
    { cc: "MZM", symbol: "MTn", name: "Mozambican metical" },
    { cc: "NAD", symbol: "N$", name: "Namibian dollar" },
    { cc: "NGN", symbol: "\u20a6", name: "Nigerian naira" },
    { cc: "NIO", symbol: "C$", name: "Nicaraguan c\u00f3rdoba" },
    { cc: "NOK", symbol: "kr", name: "Norwegian krone" },
    { cc: "NPR", symbol: "NRs", name: "Nepalese rupee" },
    { cc: "NZD", symbol: "NZ$", name: "New Zealand dollar" },
    { cc: "OMR", symbol: "OMR", name: "Omani rial" },
    { cc: "PAB", symbol: "B./", name: "Panamanian balboa" },
    { cc: "PEN", symbol: "S/.", name: "Peruvian nuevo sol" },
    { cc: "PGK", symbol: "K", name: "Papua New Guinean kina" },
    { cc: "PHP", symbol: "\u20b1", name: "Philippine peso" },
    { cc: "PKR", symbol: "Rs.", name: "Pakistani rupee" },
    { cc: "PLN", symbol: "z\u0142", name: "Polish zloty" },
    { cc: "PYG", symbol: "\u20b2", name: "Paraguayan guarani" },
    { cc: "QAR", symbol: "QR", name: "Qatari riyal" },
    { cc: "RON", symbol: "L", name: "Romanian leu" },
    { cc: "RSD", symbol: "din.", name: "Serbian dinar" },
    { cc: "RUB", symbol: "R", name: "Russian ruble" },
    { cc: "SAR", symbol: "SR", name: "Saudi riyal" },
    { cc: "SBD", symbol: "SI$", name: "Solomon Islands dollar" },
    { cc: "SCR", symbol: "SR", name: "Seychellois rupee" },
    { cc: "SDG", symbol: "SDG", name: "Sudanese pound" },
    { cc: "SEK", symbol: "kr", name: "Swedish krona" },
    { cc: "SGD", symbol: "S$", name: "Singapore dollar" },
    { cc: "SHP", symbol: "\u00a3", name: "Saint Helena pound" },
    { cc: "SLL", symbol: "Le", name: "Sierra Leonean leone" },
    { cc: "SOS", symbol: "Sh.", name: "Somali shilling" },
    { cc: "SRD", symbol: "$", name: "Surinamese dollar" },
    { cc: "SYP", symbol: "LS", name: "Syrian pound" },
    { cc: "SZL", symbol: "E", name: "Swazi lilangeni" },
    { cc: "THB", symbol: "\u0e3f", name: "Thai baht" },
    { cc: "TJS", symbol: "TJS", name: "Tajikistani somoni" },
    { cc: "TMT", symbol: "m", name: "Turkmen manat" },
    { cc: "TND", symbol: "DT", name: "Tunisian dinar" },
    { cc: "TRY", symbol: "TRY", name: "Turkish new lira" },
    { cc: "TTD", symbol: "TT$", name: "Trinidad and Tobago dollar" },
    { cc: "TWD", symbol: "NT$", name: "New Taiwan dollar" },
    { cc: "TZS", symbol: "TZS", name: "Tanzanian shilling" },
    { cc: "UAH", symbol: "UAH", name: "Ukrainian hryvnia" },
    { cc: "UGX", symbol: "USh", name: "Ugandan shilling" },
    { cc: "USD", symbol: "US$", name: "United States dollar" },
    { cc: "UYU", symbol: "$U", name: "Uruguayan peso" },
    { cc: "UZS", symbol: "UZS", name: "Uzbekistani som" },
    { cc: "VEB", symbol: "Bs", name: "Venezuelan bolivar" },
    { cc: "VND", symbol: "\u20ab", name: "Vietnamese dong" },
    { cc: "VUV", symbol: "VT", name: "Vanuatu vatu" },
    { cc: "WST", symbol: "WS$", name: "Samoan tala" },
    { cc: "XAF", symbol: "CFA", name: "Central African CFA franc" },
    { cc: "XCD", symbol: "EC$", name: "East Caribbean dollar" },
    { cc: "XDR", symbol: "SDR", name: "Special Drawing Rights" },
    { cc: "XOF", symbol: "CFA", name: "West African CFA franc" },
    { cc: "XPF", symbol: "F", name: "CFP franc" },
    { cc: "YER", symbol: "YER", name: "Yemeni rial" },
    { cc: "ZAR", symbol: "R", name: "South African rand" },
    { cc: "ZMK", symbol: "ZK", name: "Zambian kwacha" },
    { cc: "ZWR", symbol: "Z$", name: "Zimbabwean dollar" },
];

export const religion = [
    "Christianity: Various denominations including Catholicism, Protestantism, Eastern Orthodoxy.",
    "Islam: Sunni and Shia branches.",
    "Hinduism: Various sects and traditions.",
    "Buddhism: Theravada, Mahayana, Vajrayana.",
    "Judaism: Orthodox, Conservative, Reform.",
    "Sikhism",
    "Bahá'í Faith",
    "Jainism",
    "Shinto",
    "Taoism",
    "Zoroastrianism",
    "Confucianism",
    "Sufism: A mystical dimension within Islam.",
    "Baha'i Faith",
    "Jehovah's Witnesses",
    "Mormonism (Latter-day Saints)",
    "New Religious Movements (NRMs): Various smaller or newer religious groups.",
    "Others"
];
export const caste = ["Brahmin", "Kshatriya", "Vaishya", "Shudra", "Scheduled Castes (SC)", "Scheduled Tribes (ST)", "Don't Beleive In Caste"];
export const subCasteArrSmartha = [
    "Gaur", "Kanyakubja", "Saraswat"
];
export const subCasteArrMadhwa = [
    "Rajput", "Maratha", "Thakur", "Others"
];
export const subCasteArrVaishnava = ["Brahmin", "Kshatriya", "Vaishya", "Shudra", "Scheduled Castes (SC)", "Scheduled Tribes (ST)", "Don't Beleive In Caste"];
export const Raashi = [
    "Mesha",
    "Vrishabha",
    "Mithun",
    "Karka",
    "Simha",
    "Kanya",
    "Tula",
    "Vruschika",
    "Dhanu",
    "Makar",
    "Kumbha",
    "Meena",
];
export const birthStar = [
    "Ashwini",
    "Bharani",
    "Krittika",
    "Rohini",
    "Mrighasira",
    "Ardra",
    "Punarvasu",
    "Pushya",
    "Ashlesha",
    "Magha",
    "Purva Phalguni",
    "Uttara Phalguni",
    "Hasta",
    "Chitra",
    "Swati",
    "Vishaka",
    "Anuradha",
    "Jyestha",
    "Moola",
    "Purvashada",
    "Uttarashada",
    "Sharavana",
    "Dhanishta",
    "Shatabisha",
    "Purvabhadra",
    "Uttarabhadra",
    "Revati",
];

export const Gothra = [
    "Atreya / Attri",
    "Angirasa",
    "Alamban / Alambayin / Alambain",
    "Bali",
    "Bakshi",
    "Bhalki",
    "Bharadvaja",
    "Bhargava",
    "Chandrayana",
    "Charora",
    "Chyavana",
    "Dalabhya",
    "Dhananjaya",
    "Garga",
    "Gautama Maharishi",
    "Harita",
    "Jamadagni",
    "Kankar",
    "Kapil",
    "Kashyapa",
    "Kaundinya",
    "Katyayana",
    "Kaushik",
    "Kutsa",
    "Maitreya / Mitra",
    "Mandavya",
    "Mudgal",
    "Parashar",
    "Pourugutsa",
    "Sankrithi",
    "Savarni",
    "Shandilya",
    "Sharma",
    "Shunak",
    "Soral",
    "Srivatsa",
    "Suryadhwaja",
    "Upadhyay",
    "Valmiki",
    "Vashistha",
    "Vasudev",
    "Vatsa",
    "Vishnu",
    "Vishvamitra",
    "Vishnuvridha/Vishnuvardhasa",
    "Viswamitra",
    "Yaska",
    "Chalondiya",
    "Willyesh",
];
export const heightListValuePair = [
    "4ft/122cm",
    "4ft 1in/124cm",
    "4ft 2in/127cm",
    "4ft 3in/130cm",
    "4ft 4in/132cm",
    "4ft 5in/135cm",
    "4ft 6in/137cm",
    "4ft 7in/140cm",
    "4ft 8in/142cm",
    "4ft 9in/145cm",
    "4ft 10in/147cm",
    "4ft 11in/150cm",
    "5ft/152cm",
    "5ft 1in/155cm",
    "5ft 2in/157cm",
    "5ft 3in/160cm",
    "5ft 4in/163cm",
    "5ft 5in/165cm",
    "5ft 6in/168cm",
    "5ft 7in/170cm",
    "5ft 8in/173cm",
    "5ft 9in/175cm",
    "5ft 10in/178cm",
    "5ft 11in/180cm",
    "6ft/183cm",
    "6ft 1in/185cm",
    "6ft 2in/188cm",
    "6ft 3in/191cm",
    "6ft 4in/193cm",
    "6ft 5in/196cm",
    "6ft 6in/198cm",
    "6ft 7in/201cm",
    "6ft 8in/203cm",
    "6ft 9in/206cm",
    "6ft 10in/208cm",
    "6ft 11in/211cm",
    "7ft/213cm",
    "7ft 1in/216cm",
    "7ft 2in/218cm",
];
export const heightList = [
    "4ft/122cm",
    "4ft 1in/124cm",
    "4ft 2in/127cm",
    "4ft 3in/130cm",
    "4ft 4in/132cm",
    "4ft 5in/135cm",
    "4ft 6in/137cm",
    "4ft 7in/140cm",
    "4ft 8in/142cm",
    "4ft 9in/145cm",
    "4ft 10in/147cm",
    "4ft 11in/150cm",
    "5ft/152cm",
    "5ft 1in/155cm",
    "5ft 2in/157cm",
    "5ft 3in/160cm",
    "5ft 4in/163cm",
    "5ft 5in/165cm",
    "5ft 6in/168cm",
    "5ft 7in/170cm",
    "5ft 8in/173cm",
    "5ft 9in/175cm",
    "5ft 10in/178cm",
    "5ft 11in/180cm",
    "6ft/183cm",
    "6ft 1in/185cm",
    "6ft 2in/188cm",
    "6ft 3in/191cm",
    "6ft 4in/193cm",
    "6ft 5in/196cm",
    "6ft 6in/198cm",
    "6ft 7in/201cm",
    "6ft 8in/203cm",
    "6ft 9in/206cm",
    "6ft 10in/208cm",
    "6ft 11in/211cm",
    "7ft/213cm",
    "7ft 1in/216cm",
    "7ft 2in/218cm",
];
export const age = ["18", "19", "20"];
export const languages = [
    "Kannada",
    "Telugu",
    "Tamil",
    "Marathi",
    "Tulu",
    "Hindi",
    "Sanskrit",
    "Odia"
];

export const employedin = [
    "Any",
    "Government",
    "IT Sector",
    "Private",
    "Business",
];
